export default {
  Button: {
    Sort: 'Sắp xếp để thay đổi vị trí',
    Delete: 'Xóa',
    UnDelete: 'Còn 1 chân chữ ký không được xóa',
    Add: 'Thêm',
    UnAdd: 'Không thể thêm quá 3 chân chữ ký',
  },
  Toast: {
    SaveNewSuccess: 'Cất và lưu thành mẫu mới thành công',
    SaveNewError: 'Cất và lưu thành mẫu mới thất bại',
    Duplicate: 'Tên mẫu bị trùng. Vui lòng đặt lại tên khác.',
  }
};
